import { useQuery } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { PageType } from '../../types/domain.types';

const getPage = (pageId: number): Promise<{ page: PageType }> =>
  api.get(`/pages/${pageId}`);

export const useGetPageQuery = ({ pageId }: { pageId: number }) => {
  return useQuery({
    queryKey: ['page', pageId],
    queryFn: () => getPage(pageId),
    enabled: !!pageId,
    select: (data) => data.page,
  });
};
